'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZES = exports.TYPES = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPES = exports.TYPES = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  TERTIARY: 'TERTIARY',
  WARNING: 'WARNING',
  DANGER: 'DANGER',
  DISABLED: 'DISABLED'
};

var SIZES = exports.SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  BIG: 'BIG',
  HERO: 'HERO'
};

var EnterpriseButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseButton, _Component);

  function EnterpriseButton() {
    (0, _classCallCheck3.default)(this, EnterpriseButton);
    return (0, _possibleConstructorReturn3.default)(this, (EnterpriseButton.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(EnterpriseButton, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          children = _props.children,
          type = _props.type,
          size = _props.size,
          fill = _props.fill,
          className = _props.className,
          restProps = (0, _objectWithoutProperties3.default)(_props, ['children', 'type', 'size', 'fill', 'className']);

      var styles = require('./EnterpriseButton.scss');

      var buttonModifiers = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, styles.primary, type === TYPES.PRIMARY), (0, _defineProperty3.default)(_cx, styles.secondary, type === TYPES.SECONDARY), (0, _defineProperty3.default)(_cx, styles.tertiary, type === TYPES.TERTIARY), (0, _defineProperty3.default)(_cx, styles.warning, type === TYPES.WARNING), (0, _defineProperty3.default)(_cx, styles.danger, type === TYPES.DANGER), (0, _defineProperty3.default)(_cx, styles.disabled, type === TYPES.DISABLED), (0, _defineProperty3.default)(_cx, styles.small, size === SIZES.SMALL), (0, _defineProperty3.default)(_cx, styles.medium, size === SIZES.MEDIUM), (0, _defineProperty3.default)(_cx, styles.big, size === SIZES.BIG), (0, _defineProperty3.default)(_cx, styles.hero, size === SIZES.HERO), (0, _defineProperty3.default)(_cx, styles.fill, fill), _cx));

      return _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, restProps, { className: (0, _classnames2.default)(className, styles.root, buttonModifiers) }),
        children
      );
    }
  }]);
  return EnterpriseButton;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.node,
  type: _react.PropTypes.string,
  size: _react.PropTypes.string,
  fill: _react.PropTypes.bool,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  type: TYPES.PRIMARY,
  size: SIZES.MEDIUM,
  fill: false
}, _temp);
exports.default = EnterpriseButton;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseButton/EnterpriseButton.jsx
// module id = 346
// module chunks = 0